import getSessionKey from '@core/utils/getSessionKey';

/**
 * The key for the property that contains the shared SWR cache
 * in the window.
 */
const globalCache = `@readmeSWR-${getSessionKey()}`;

/**
 * Creates an SWR cache that is shared between the main app and the
 * preview iframe in SuperHub.
 *
 * @example
 * <SWRConfig value={{ provider: crossFrameSwrCache }}>
 */
export default function crossFrameSwrCache() {
  const isClient = typeof window !== 'undefined';
  const isParent = isClient && window.self === window.top;

  // https://bin.readme.com/ will load an iframe with the Hub app from 'preview.readme.io'
  // In this case we don't want to share the cache across frames.
  const isBinPreviewSite = process.env.NODE_ENV === 'playground';

  // Skip this function if we are in a server or playground environment.
  if (!isClient || isBinPreviewSite) {
    return new Map();
  }

  // If we are in a parent window, create a new SWR cache and tack it to the global
  // `window` object so that it can be accessed by child iframes.
  if (isParent) {
    window[globalCache] ??= new Map();
    return window[globalCache];
  }

  // If we are in an iframe, return the SWR cache from the parent window.
  // If it doesn't exist, create a new one and store it in the parent window.
  window.parent[globalCache] ??= new Map();
  return window.parent[globalCache];
}
